import { Cwb_PositionalAttribute } from "../../../../Shared/Shared.js";
import { ofArray } from "../../../../fable_modules/fable-library.3.7.9/List.js";

export const word = new Cwb_PositionalAttribute("word", "Word form");

export const pos = new Cwb_PositionalAttribute("pos", "Part-of-speech");

export const lemma = new Cwb_PositionalAttribute("lemma", "Lemma");

export const orig = new Cwb_PositionalAttribute("orig", "Original form");

export const descr = new Cwb_PositionalAttribute("descr", "Description");

export const list = ofArray([pos, lemma, orig, descr]);

